import React from 'react';
import history from '../../history';

import Table from 'components/table';

export const changeStatus = status => {
  switch (status) {
    case 0:
      return <div style={{color: "#edbd2f", display: "inline-block"}}>На розгляді</div>
    case 1:
      return <div style={{color: "#008d4c", display: "inline-block"}}>Підтверджено</div>
    case 2:
      return <div style={{color: "#d73925", display: "inline-block"}}>Відхилено</div>
    default:
  }
}

export const RecordsList = ({ records }) => (
  <Table black hover>
    <thead>
      <tr>
        <th>Номер запису</th>
        <th>Час</th>
        <th>Лікарня</th>
        <th>Лікар</th>
        <th>Кабінет</th>
        <th>Стан</th>
      </tr>
    </thead>
    <tbody>
      {records.map((record, i) => (
        <tr key={record.get('id')} onClick={() => history.push(`/registry/records/detail/${record.get('id')}`)}>
          <td><span>Номер запису:</span>{record.get('id')}</td>
          <td><span>Час:</span>{record.get('reception_data').get('start_date')}, {new Date('2018-01-01T' + record.get('reception_data').get('start_time')).toLocaleTimeString('uk-UA', {hour: '2-digit', minute:'2-digit'})}</td>
          <td><span>Лікарня:</span>{record.get('reception_data').get('staff_data').get('institution_data').get('full_title')}</td>
          <td><span>Лікар:</span>{record.get('reception_data').get('staff_data').get('user_data').get('last_name')} {record.get('reception_data').get('staff_data').get('user_data').get('first_name')} {record.get('reception_data').get('staff_data').get('user_data').get('middle_name')}</td>
          <td><span>Кабінет:</span>{record.get('reception_data').get('staff_data').get('cabinet_number')}</td>
          <td><span>Стан:</span>{changeStatus(record.get('status'))}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)



// WEBPACK FOOTER //
// ./src/registry/records/records-list.js